import React from 'react';
import { useParams } from 'react-router-dom';
import MainContentContainer from './../../MainContentContainer/MainContentContainer';
import SubCategoriesTable from './../../SubCategoriesTable/SubCategoriesTable';

const SubCategoryPage = () => {
  const { id } = useParams();

  return (
    <SubCategoriesTable selectedId={id} />
  );
};

export default SubCategoryPage;